module.exports = __webpack_public_path__ + "static/media/country_codes_dialing_A2_A3.0d2b7c57.csv";